import { forRails } from 'components/for-rails'
import { BuildWizardPage } from 'components/onboarding-build-wizard'
import { OnboardingFrameworkSetupHelper } from 'components/onboarding-framework-setup-helper/onboarding-framework-setup-helper'
import { registerComponents } from '../src/utils/react/registry'

registerComponents({
  OnboardingFrameworkSetupHelper: forRails(OnboardingFrameworkSetupHelper),
  BuildWizardPage: forRails(BuildWizardPage),
})
